import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button,
} from "@mui/material";

function ResetPasswordPage() {
  const navigate = useNavigate();
  const [open, setOpen] = useState("");
  const [openConfirmation, setOpenConfirmation] = useState("");
  const [showNewPassword, setShowNewPassword] = useState(true);
  const [showConfirmNewPassword, setShowConfirmNewPassword] = useState(true);
  const [newPassword, setNewPassword] = useState("");
  const [confirmNewPassword, setConfirmNewPassword] = useState("");
  const [tokenExpired, setTokenExpired] = useState("");
  const [error, setError] = useState("");

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);

  useEffect(() => {
    resetPassword(searchParams.get("resetToken"));
  }, []);

  const resetPassword = async (resetToken) => {
    const formData = {
      resetToken: resetToken,
    };
    try {
      const response = await fetch(
        "https://lbhaw84n6b.execute-api.ap-southeast-3.amazonaws.com/xcp/auth/reset-password",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
        }
      );

      const data = await response.json();

      const responseBody = JSON.parse(data.body);
      if (!response.ok) {
        throw new Error(data.message || "Failed to check token");
      }

      const { message } = responseBody;
      const statusCode = data.statusCode;
      if (message == "Token is valid") {
        setOpen(true);
        setOpenConfirmation(false);

      } else {
        setTokenExpired(true);
      }
    } catch (error) {
      console.error("Submission Error:", error.message);
    }
  };

  const handleClose = () => {
    setOpen(false);
    navigate("/login");
  };

  const handleConfirmation = async (event) => {
    setError("");
    
    if (!newPassword || !confirmNewPassword) {
      setError("Password fields cannot be empty.");
      return;
    }

    if (newPassword !== confirmNewPassword) {
      setError("Passwords do not match.");
      return;
    }

    let resetToken = searchParams.get("resetToken");
    const formData = {
      newPassword: newPassword,
      confirmNewPassword: confirmNewPassword,
      resetToken: resetToken,
    };

    try {
      const response = await fetch(
        "https://lbhaw84n6b.execute-api.ap-southeast-3.amazonaws.com/xcp/auth/reset-password",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
        }
      );

      const data = await response.json();
      const responseBody = JSON.parse(data.body);
      if (!response.ok) {
        throw new Error(data.message || "Failed to submit form");
      }

      const { message } = responseBody;
      const statusCode = data.statusCode;
      if (message == "success") {
        setOpen(false);
        setOpenConfirmation(true);

      } else {
        setError(responseBody.message || "Network response was not ok.");
      }
    } catch (error) {
      console.error("Submission Error:", error.message);
    }
  };

  const handleFinish = () => {
    setOpenConfirmation(false);
    navigate("/login");
  };

  const toggleShowNewPassword = () => {
    setShowNewPassword(!showNewPassword);
  };

  const toggleShowConfirmNewPassword = () => {
    setShowConfirmNewPassword(!showConfirmNewPassword);
  };

  return (
    <div>
      <div>
        <Dialog open={open} onClose={handleClose}>
          <DialogTitle
            style={{ textAlign: "left", fontWeight: "bold", fontSize: "24px" }}
          >
            {"Cross Connect Reset Password"}
          </DialogTitle>

          <form style={{ textAlign: "left" }}>
            <div
              className="textbox-cp"
              style={{
                marginLeft: 24,
                position: "relative",
                display: "inline-block",
              }}
            >
              <label htmlFor="newPassword">New Password</label>
              <input
                type={!showNewPassword ? "text" : "password"}
                placeholder="New Password"
                onChange={(e) => setNewPassword(e.target.value)}
                required
                style={{ paddingRight: "200px" }}
              />
              <span
                onClick={toggleShowNewPassword}
                style={{
                  position: "absolute",
                  right: "-120px",
                  top: "75%",
                  transform: "translateY(-50%)",
                  cursor: "pointer",
                }}
              >
                <i
                  className={showNewPassword ? "bi bi-eye-slash" : "bi bi-eye"}
                ></i>
              </span>
            </div>
            <div
              className="textbox-cp"
              style={{
                marginLeft: 24,
                position: "relative",
                display: "inline-block",
              }}
            >
              <label htmlFor="confirmNewPassword">Confirm New Password</label>
              <input
                type={!showConfirmNewPassword ? "text" : "password"}
                placeholder="Confirm New Password"
                onChange={(e) => setConfirmNewPassword(e.target.value)}
                required
                style={{ paddingRight: "200px" }}
              />
              <span
                onClick={toggleShowConfirmNewPassword}
                style={{
                  position: "absolute",
                  right: "-120px",
                  top: "75%",
                  transform: "translateY(-50%)",
                  cursor: "pointer",
                }}
              >
                <i
                  className={
                    showConfirmNewPassword ? "bi bi-eye-slash" : "bi bi-eye"
                  }
                ></i>
              </span>
            </div>
            <div style={{ marginLeft: 24 }}>
              {error && <p className="error-message">{error}</p>}
            </div>

            <div style={{ marginLeft: 24 }} className="password-requirements">
              <p>Password requirements:</p>
              <p>1. Password length between 6 to 20 characters</p>
              <p>
                2. Password contains combination between upper case and lower
                case character
              </p>
              <p>3. Password contains at least 1 number</p>
              <p>4. Password contains at least 1 special character</p>
            </div>
          </form>

          <DialogActions>
            <Button onClick={handleClose} color="primary">
              Cancel
            </Button>
            <Button onClick={handleConfirmation} color="primary" autoFocus>
              Reset Password
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog open={openConfirmation}>
          <DialogTitle>{"Reset Password succesfully"}</DialogTitle>
          <DialogActions>
            <Button onClick={handleFinish} color="primary" autoFocus>
              OK
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog open={tokenExpired}>
          <DialogTitle>{"Link has been expired."}</DialogTitle>
          <DialogActions>
            <Button onClick={handleFinish} color="primary" autoFocus>
              OK
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    </div>
  );
}

export default ResetPasswordPage;
